import MapComponent from "../../../../../../common/components/organisme/MapComponent/MapComponent";

export interface StationLocationViewProps {
  lng?: number;
  lat?: number;
  namePin?: string;
  zIndex?: number;
}

export default function StationLocationView({
  lng,
  lat,
  namePin,
  zIndex = 1,
}: StationLocationViewProps) {
    
  return (
    <>
      {lng !== undefined && lat !== undefined && (
       
          <MapComponent
            center={[lat, lng]}
            zoom={13}
            pinList={[
              { position: [lat, lng], name: namePin || lat + " " + lng },
            ]}
            style={{
              height: "100%",
              width: "100%",
              borderRadius: "20px",
              position: "relative",
              zIndex: zIndex,
            }}
          />
 
      )}
    </>
  );
}
